import axios from '@/plugins/axios';
import { getAccessToken } from '@/utils/token';

const SUB_ACCOUNT = '/sub-account';
const CHECK_MAIL = '/sub-account-validate-email-duplication';
const COUNT_SUB_ACCOUNT = '/get-quantity-sub-account';
const CREATION_PERMISSION = 'check-creation-permission';
const GET_MODULE_MASTER_ACTIVE = '/get-module-master-active';
const token = getAccessToken();

export async function checkmail(payload) {
  try {
    const { data } = await axios.post(`${CHECK_MAIL}`, payload);
    return data;
  } catch (error) {
    return { error };
  }
}

export async function getList(param) {
  try {
    const { data } = await axios.get(SUB_ACCOUNT, { params: param });

    return data;
  } catch (error) {
    return { error };
  }
}

export async function show(id) {
  try {
    const data = await axios.get(`${SUB_ACCOUNT}/${id}`);

    return data;
  } catch (error) {
    return { error };
  }
}

export async function update(id, payload) {
  try {
    const data = await axios.put(`${SUB_ACCOUNT}/${id}`, payload);

    return data;
  } catch (error) {
    return { error };
  }
}

export async function create(payload) {
  try {
    const data = await axios.post(SUB_ACCOUNT, payload);

    return data;
  } catch (error) {
    return { error };
  }
}

export async function remove(id) {
  try {
    const data = await axios.delete(`${SUB_ACCOUNT}/${id}`);
    console.log(`data from API `, data);

    return data;
  } catch (error) {
    return { error };
  }
}

export async function nextPage(param) {
  try {
    const { data } = await axios.get(param);

    return data;
  } catch (error) {
    return { error };
  }
}

export async function changePage(param) {
  try {
    const { data } = await axios.get(SUB_ACCOUNT, { params: param });

    return data;
  } catch (error) {
    return { error };
  }
}

export async function countSubAccount(param) {
  try {
    const { data } = await axios.get(COUNT_SUB_ACCOUNT);

    return data;
  } catch (error) {
    return { error };
  }
}
export async function checkCreationPermission() {
  try {
    const data = await axios.post(`${SUB_ACCOUNT}/${CREATION_PERMISSION}`);

    return data;
  } catch (error) {
    return error;
  }
}
export async function getModuleMasterActive() {
  try {
    const data = await axios.get(`${GET_MODULE_MASTER_ACTIVE}`);

    return data;
  } catch (error) {
    return error;
  }
}
